import React, { useEffect, useState, ChangeEvent, SyntheticEvent } from 'react'

import axios from 'axios'
import Swal from 'sweetalert2'
import CircularProgress from '@mui/material/CircularProgress'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import TextField from '@mui/material/TextField'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'
import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import InputLabel from '@mui/material/InputLabel'
import { darken, lighten, styled } from '@mui/material/styles'
import Box, { BoxProps } from '@mui/material/Box'
import { useTheme } from '@mui/material/styles'
import {
    CardActions,
    Divider,
    FormControl,
    FormControlLabel,
    FormHelperText,
    IconButton,
    InputAdornment,
    Radio,
    RadioGroup,
    Tooltip
} from '@mui/material'

import Tab from '@mui/material/Tab'
import TabList from '@mui/lab/TabList'
import TabPanel from '@mui/lab/TabPanel'
import TabContext from '@mui/lab/TabContext'

import TableContainer from '@mui/material/TableContainer'
import Table from '@mui/material/Table'
import TableRow from '@mui/material/TableRow'
import TableBody from '@mui/material/TableBody'
import TableCell, { TableCellBaseProps } from '@mui/material/TableCell'
import TableHead from '@mui/material/TableHead'
import Button from '@mui/material/Button'
import { NumericFormat, NumericFormatProps } from 'react-number-format'

import apiUrl from '../../configs/constant';
import Icon from '../../components/icon';
import { useNavigate } from 'react-router-dom'
import MsiDatagrid from '../custom/MsiDatagridAuto'

const tableFixHead = { position: 'sticky', top: 0, zIndex: 3 }
const styleCell = {
    textAlign: 'center',
    border: '0.5px solid rgba(0, 0, 0, 0.12)'
}
const styleCellHeader = {
    backgroundColor: '#EDEDED',
    textAlign: 'center',
    border: '0.5px solid rgba(0, 0, 0, 0.12)'
}
const titleHeader = {
    textTransform: 'none',
    color: 'text.primary',
    textAlign: 'center',
    fontWeight: 600,
    fontSize: 15
}
const contentPrimary = {
    color: 'text.primary',
    textAlign: 'center',
    fontWeight: 400,
    fontSize: 15
}
const contentPrimaryBold = {
    color: 'text.primary',
    textAlign: 'center',
    fontWeight: 'bold',
    fontSize: 15,
    cursor: 'pointer'
}

interface Props {
    array: any
    title: any
    stock?: any
    metode?: any
    indexArr: any
    refresh: (indexArr: any) => void
}

const TablePR = (props: Props) => {
    const theme = useTheme()
    const navigate = useNavigate();

    const userData = JSON.parse(localStorage.getItem('user')!)
    const user = userData.data
    const token = userData.token

    // ** Props
    const { array, title, refresh, indexArr, stock, metode } = props

    // ** State
    const [listData, setListData] = useState<any[]>([])
    const [listArray, setListArray] = useState<any[]>([])
    const [valueTabs, setValueTabs] = useState<string>('0')
    const [openDialog, setOpenDialog] = useState<boolean>(false)
    const [openDialogPrPo, setOpenDialogPrPo] = useState<boolean>(false)
    const [loading, setLoading] = useState<boolean>(false)

    const [listDataAktif, setListDataAktif] = useState<any[]>([])
    const [listDataBelumAktif, setListDataBelumAktif] = useState<any[]>([])
    const [detailID, setDetailID] = useState<string>('0')

    useEffect(() => {
        setListArray(array)
    }, [array])

    const getDataAktif = (ids: any) => {
        setDetailID(ids)
        setLoading(true)
        const data = {
            query: `call sp_get_forecast_kebutuhan_chem_list(${ids},1)`
        }

        const url = apiUrl.apiUrl + '/api/system/run-query'
        axios
            .get(url, {
                params: data,
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setListDataAktif(data)
                    getDataBelumAktif(ids)
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })
    }

    const getDataBelumAktif = (ids: any) => {
        const data = {
            query: `call sp_get_forecast_kebutuhan_chem_list(${ids},1)`
        }

        const url = apiUrl.apiUrl + '/api/system/run-query'
        axios
            .get(url, {
                params: data,
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setListDataBelumAktif(data)
                    setLoading(false)
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })
    }

    const getDataPo = (ids: any) => {
        setLoading(true)
        const data = {
            query: `call sppb_pbpr_chem_po_list(${ids})`
        }

        const url = apiUrl.apiUrl + '/api/system/run-query'
        axios
            .get(url, {
                params: data,
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setListData(data)
                    setLoading(false)
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })
    }

    const getDataPr = (ids: any) => {
        setLoading(true)
        const data = {
            query: `call sppb_pbpr_chem_pr_list(${ids})`
        }

        const url = apiUrl.apiUrl + '/api/system/run-query'
        axios
            .get(url, {
                params: data,
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setListData(data)
                    setLoading(false)
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })
    }

    const handleChangeTabs = (event: SyntheticEvent, newValue: string) => {
        setValueTabs(newValue)
    }

    const handleClickDialog = (id: any) => {
        setOpenDialog(true)
        getDataAktif(id)
    }
    const handleCloseDialog = () => {
        setOpenDialog(false)
    }

    const handleClickDialogPrPo = (id: any, mode: any) => {
        setOpenDialogPrPo(true)
        if (mode == 'po') {
            getDataPo(id)
        } else {
            getDataPr(id)
        }
    }

    const changeValueAksi = (params: any) => {
        const rows = [...listArray]
        let index = rows.map(o => o.i).indexOf(params.i)
        rows[index].qty_order = 0
        setListArray(rows)
    }

    const changeValue = (params: any, qty: any) => {
        const rows = [...listArray]
        let index = rows.map(o => o.i).indexOf(params.i)
        rows[index].qty_order = qty
        setListArray(rows)
    }

    const handleBuatPR = () => {
        const resultArr = listArray.filter(item => item.qty_order !== 0 && item.qty_order !== '0')

        if (resultArr.length == 0) {
            Swal.fire({
                title: `Qty order ${title} kosong`,
                text: `Silahkan masukkan Qty order terlebih dahulu`,
                icon: 'error'
            })
        } else {
            Swal.fire({
                title: 'Konfirmasi',
                html: `Apakah anda ingin buat PR Chemical ${title} ?`,
                icon: 'question',
                showCancelButton: true,
                confirmButtonColor: '#337ab7',
                cancelButtonColor: '#ffc107',
                confirmButtonText: 'Buat PR'
            }).then(result => {
                if (result.isConfirmed) {
                    Swal.fire({
                        title: 'Now loading',
                        allowEscapeKey: false,
                        allowOutsideClick: false,
                        didOpen: () => {
                            Swal.showLoading()
                        }
                    })

                    const send = {
                        array: JSON.stringify(resultArr),
                        keterangan_pembelian: title
                    }

                    const url = apiUrl.apiUrl + '/api/purchasing/pr/save-pr-chemical'
                    axios
                        .post(url, send, {
                            headers: { Authorization: `Bearer ${token}` }
                        })
                        .then(response => {
                            if (response.data.success) {
                                Swal.fire({
                                    title: 'Pemberitahuan',
                                    html: response.data.message,
                                    icon: 'success',
                                    timer: 1000,
                                    timerProgressBar: true,
                                    willClose: () => {
                                        refresh(indexArr)
                                    }
                                })
                            } else {
                                Swal.fire({
                                    title: 'Pemberitahuan',
                                    html: response.data.message,
                                    icon: 'error'
                                })
                            }
                        })
                        .catch(error => {
                            Swal.fire({
                                title: 'Pemberitahuan',
                                text: error.message,
                                icon: 'error'
                            })
                        })
                }
            })
        }
    }

    return (
        <Box>
            <Box
                sx={{
                    mt: 2,
                    gap: 5,
                    display: 'flex',
                    flexWrap: 'wrap',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    p: theme => theme.spacing(0, 0, 2, 0)
                }}
            >
                <Typography variant='body1'>
                    Minimum Stock untuk Kebutuhan : <b>{stock}</b>
                </Typography>
                <Typography variant='body1'>
                    Metode Hitung: <b>{metode}</b>
                </Typography>
                <Button
                    variant='contained'
                    color='secondary'
                    startIcon={<Icon icon='mdi:text-box-check-outline' />}
                    onClick={handleBuatPR}
                >
                    BUAT PR {title}
                </Button>
            </Box>
            <Table>
                <TableHead sx={tableFixHead}>
                    <TableRow>
                        <TableCell colSpan={2} sx={styleCellHeader}>
                            <Typography sx={titleHeader}>{title}</Typography>
                        </TableCell>
                        <TableCell colSpan={3} sx={styleCellHeader}>
                            <Typography sx={titleHeader}>STOCK</Typography>
                        </TableCell>
                        <TableCell colSpan={2} sx={styleCellHeader}>
                            <Typography sx={titleHeader}>FORECAST</Typography>
                        </TableCell>
                        <TableCell colSpan={2} sx={styleCellHeader}>
                            <Typography sx={titleHeader}>OUTSTANDING</Typography>
                        </TableCell>
                        <TableCell rowSpan={2} sx={styleCellHeader}>
                            <Typography sx={titleHeader}>SUGGESTED QTY</Typography>
                        </TableCell>
                        <TableCell rowSpan={2} sx={styleCellHeader}>
                            <Typography sx={titleHeader}>QTY ORDER</Typography>
                        </TableCell>
                        <TableCell rowSpan={2} sx={styleCellHeader}>
                            <Typography sx={titleHeader}>AKSI</Typography>
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell sx={styleCellHeader}>
                            <Typography sx={titleHeader}>PROSES</Typography>
                        </TableCell>
                        <TableCell sx={styleCellHeader}>
                            <Typography sx={titleHeader}>JENIS CHEMICAL</Typography>
                        </TableCell>
                        <TableCell sx={styleCellHeader}>
                            <Typography sx={titleHeader}>SUBSTORE</Typography>
                        </TableCell>
                        <TableCell sx={styleCellHeader}>
                            <Typography sx={titleHeader}>GUDANG</Typography>
                        </TableCell>
                        <TableCell sx={styleCellHeader}>
                            <Typography sx={titleHeader}>MINIMUM</Typography>
                        </TableCell>
                        <TableCell sx={styleCellHeader}>
                            <Typography sx={titleHeader}>KEBUTUHAN</Typography>
                        </TableCell>
                        <TableCell sx={styleCellHeader}>
                            <Typography sx={titleHeader}>ESTIMASI</Typography>
                        </TableCell>
                        <TableCell sx={styleCellHeader}>
                            <Typography sx={titleHeader}>PR</Typography>
                        </TableCell>
                        <TableCell sx={styleCellHeader}>
                            <Typography sx={titleHeader}>PO</Typography>
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {listArray.map((el, index) => {
                        return (
                            <TableRow key={index}>
                                <TableCell sx={styleCell}>
                                    <Typography sx={contentPrimary}>{el.proses}</Typography>
                                </TableCell>
                                <TableCell sx={styleCell}>
                                    <a
                                        target='_blank'
                                        style={{ textDecoration: 'none' }}
                                        href={'/mm/chemical/master-jenis-chemical/view/?jenis_chemical=' + el.jenis_chemical}
                                    >
                                        <Typography sx={contentPrimaryBold}>{el.jenis_chemical}</Typography>
                                    </a>
                                </TableCell>
                                <TableCell sx={[styleCell, { backgroundColor: theme.palette.info.light }]}>
                                    <Typography sx={contentPrimary}>
                                        {el.substore?.toLocaleString('id-ID', { maximumFractionDigits: 2 })}
                                    </Typography>
                                </TableCell>
                                <TableCell sx={[styleCell, { backgroundColor: theme.palette.info.light }]}>
                                    <Typography sx={contentPrimary}>
                                        {el.total_stock?.toLocaleString('id-ID', { maximumFractionDigits: 2 })}
                                    </Typography>
                                </TableCell>
                                <TableCell sx={[styleCell, { backgroundColor: theme.palette.error.light }]}>
                                    <Typography sx={contentPrimary}>
                                        {el.minimum_stock?.toLocaleString('id-ID', { maximumFractionDigits: 2 })}
                                    </Typography>
                                </TableCell>
                                <TableCell
                                    sx={[styleCell, { backgroundColor: theme.palette.error.light }]}
                                    onClick={() => handleClickDialog(el.id)}
                                >
                                    <Typography sx={contentPrimaryBold}>
                                        {el.kebutuhan_forecast?.toLocaleString('id-ID', { maximumFractionDigits: 2 })}
                                    </Typography>
                                </TableCell>
                                <TableCell sx={styleCell}>
                                    <Typography sx={contentPrimary}>
                                        {el.estimasi_forecast?.toLocaleString('id-ID', { maximumFractionDigits: 2 })}
                                    </Typography>
                                </TableCell>
                                <TableCell
                                    sx={[styleCell, { backgroundColor: theme.palette.warning.light }]}
                                    onClick={() => handleClickDialogPrPo(el.id, 'pr')}
                                >
                                    <Typography sx={contentPrimaryBold}>
                                        {el.pr_outstanding?.toLocaleString('id-ID', { maximumFractionDigits: 2 })}
                                    </Typography>
                                </TableCell>
                                <TableCell
                                    sx={[styleCell, { backgroundColor: theme.palette.warning.light }]}
                                    onClick={() => handleClickDialogPrPo(el.id, 'po')}
                                >
                                    <Typography sx={contentPrimaryBold}>
                                        {el.po_outstanding?.toLocaleString('id-ID', { maximumFractionDigits: 2 })}
                                    </Typography>
                                </TableCell>
                                <TableCell sx={styleCell}>
                                    <Typography sx={contentPrimary}>
                                        {el.qty_suggested?.toLocaleString('id-ID', { maximumFractionDigits: 2 })}
                                    </Typography>
                                </TableCell>
                                <TableCell sx={styleCell}>
                                    <TextField
                                        id='qty_order'
                                        fullWidth
                                        type='number'
                                        onChange={e => {
                                            const val = e.target.value
                                            changeValue(el, val)
                                        }}
                                        label='Qty Order'
                                        value={el.qty_order}
                                        sx={{
                                            '& .MuiOutlinedInput-root': {
                                                '& fieldset': {
                                                    borderColor: el.qty_order == 0 ? theme.palette.error.main : theme.palette.primary.main
                                                },
                                                '&:hover fieldset': {
                                                    borderColor: el.qty_order == 0 ? theme.palette.error.dark : theme.palette.primary.dark
                                                },
                                                '&.Mui-focused fieldset': {
                                                    borderColor: el.qty_order == 0 ? theme.palette.error.main : theme.palette.primary.main
                                                }
                                            },
                                            '& .MuiInputBase-input': {
                                                color: el.qty_order == 0 ? theme.palette.error.main : theme.palette.primary.main
                                            }
                                        }}
                                    />
                                </TableCell>
                                <TableCell sx={styleCell}>
                                    <IconButton color='error'>
                                        <Icon icon='mdi:close-circle' fontSize={20} onClick={() => changeValueAksi(el)} />
                                    </IconButton>
                                </TableCell>
                            </TableRow>
                        )
                    })}
                </TableBody>
            </Table>
            <Dialog
                maxWidth={'lg'}
                fullWidth={true}
                open={openDialog}
                onClose={handleCloseDialog}
                aria-labelledby='form-dialog-title'
            >
                <DialogTitle id='form-dialog-title'>Detail : {detailID}</DialogTitle>
                <DialogContent>
                    <Grid container spacing={1}>
                        <Grid item xs={12} md={12}>
                            {loading ? (
                                <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center', margin: 10 }}>
                                    <CircularProgress disableShrink sx={{ mt: 6, height: '100%' }} />
                                </Grid>
                            ) : (
                                <TabContext value={valueTabs}>
                                    <TabList
                                        sx={{ ml: -5 }}
                                        scrollButtons
                                        variant='scrollable'
                                        onChange={handleChangeTabs}
                                        aria-label='forced scroll tabs example'
                                    >
                                        <Tab value='0' label='DOKUMEN AKTIF' />
                                        <Tab value='1' label='DOKUMEN BELUM AKTIF' />
                                    </TabList>
                                    <TabPanel value='0'>
                                        <MsiDatagrid array={listDataAktif} />
                                    </TabPanel>
                                    <TabPanel value='1'>
                                        <MsiDatagrid array={listDataBelumAktif} />
                                    </TabPanel>
                                </TabContext>
                            )}
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions className='dialog-actions-dense'>
                    <Button onClick={handleCloseDialog}>Close</Button>
                </DialogActions>
            </Dialog>

            <Dialog
                maxWidth={'lg'}
                fullWidth={true}
                open={openDialogPrPo}
                onClose={() => setOpenDialogPrPo(false)}
                aria-labelledby='form-dialog-title'
            >
                <DialogTitle id='form-dialog-title' textAlign='center'>
                    DETAIL LIST
                </DialogTitle>
                <DialogContent>
                    <Grid container spacing={4} sx={{ mt: 1 }}>
                        <Grid item xs={12} md={12}>
                            {loading ? (
                                <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center', margin: 10 }}>
                                    <CircularProgress disableShrink sx={{ mt: 6, height: '100%' }} />
                                </Grid>
                            ) : (
                                <MsiDatagrid array={listData} />
                            )}
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions className='dialog-actions-dense'>
                    <Button onClick={() => setOpenDialogPrPo(false)}>Close</Button>
                </DialogActions>
            </Dialog>
        </Box>
    )
}

export default TablePR
